// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-name[data-v-8f60e386]{right:0}.front[data-v-8f60e386]{z-index:2000000}", ""]);
// Exports
module.exports = exports;
